import { useNavigation } from "@react-navigation/native"
import { Button, useTheme, useUser } from "capsule"
import React, { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet, View } from "react-native"

import { Organ } from "../../common/Pathology"
import PatientsList from "../../components/PatientsList"
import { useStoreReviewRequest } from "../../features/hooks/useStoreReviewRequest"
import { PatientsListNS, PractitionerHomeNS } from "../../features/i18n/constants"

interface IProps {
  organ?: Organ
}

const PatientsListScreen: FC<IProps> = ({ organ }) => {
  const {
    dimensions: { spacing },
    colors: { surface },
  } = useTheme()
  const { t } = useTranslation(PatientsListNS)
  const navigation = useNavigation<any>()
  const { userData } = useUser()
  const isSurgeon = userData?.role === "surgeon"

  // Utiliser le hook personnalisé pour les demandes d'avis sur les stores
  useStoreReviewRequest()

  const s = useMemo(
    () => ({
      view: [
        styles.view,
        {
          backgroundColor: surface.background,
        },
      ],
    }),
    [surface.background],
  )

  return (
    <View style={s.view}>
      <Button
        testID="add-patient-btn"
        style={{ margin: spacing, marginBottom: spacing / 2 }}
        onPress={() => navigation.navigate("AddPatient")}
      >
        {t("add")}
      </Button>
      {isSurgeon ? (
        <Button
          style={{ marginHorizontal: spacing, marginBottom: spacing }}
          onPress={() =>
            navigation.navigate("Codes", {
              screen: "PrescriptionLCAEligibility",
              initial: false,
            })
          }
        >
          {t(`${PractitionerHomeNS}:button.prescriptionLCA`)}
        </Button>
      ) : null}
      <PatientsList organ={organ?.id} />
    </View>
  )
}

export default PatientsListScreen

const styles = StyleSheet.create({
  view: {
    flex: 1,
  },
})
